export default {
    shield: 'その他',
    shield_battle: 'その他',
    champions_league: '大型大会'
}
